import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { SalesreportComponent } from './salesreport/salesreport.component';
import { PurchasereportComponent } from './purchasereport/purchasereport.component';
import { StockreportComponent } from './stockreport/stockreport.component'; 
import { DashboardComponent } from './dashboard/dashboard.component';
import { SalesapprovalComponent } from './salesapproval/salesapproval.component';
import { StockexchangeComponent } from './stockexchange/stockexchange.component';
import { StockCheckingApprovalComponent } from './StockChecking-Approval/stock-checking-approval/stock-checking-approval.component'

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },

  
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
        { path: 'salesreport', component: SalesreportComponent },
         { path: 'purchasereport', component: PurchasereportComponent },
          { path: 'stockreport', component: StockreportComponent },
          { path: 'salesapproval', component: SalesapprovalComponent },
           { path: 'stockexchange', component: StockexchangeComponent },
      { path: 'home', component: DashboardComponent }, 
      {path:'stockchecking',component:StockCheckingApprovalComponent }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
